import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours } from "@/utils";
import { Device } from "@/utils/device";
import { CL } from "@/components/Typography";
import RxContentBlockTitle from "@/components/ui/display/RxContentBlockTitle";

const CareersJoinContent: FunctionComponent = () => {
  return (
    <S.Section>
      <S.CopyContainer>
        <RxContentBlockTitle>
          <S.RoxboroughFontWrap>
            <S.Italic>Join a </S.Italic>community <br />
          </S.RoxboroughFontWrap>
          of changemakers
        </RxContentBlockTitle>
        <CL weight="700">
          A career at AllBright isn’t just a job. It’s a call to a mission,
          supported by robust learning programmes and a real opportunity to
          develop up the career ladder.
        </CL>
        <CL>
          Hone your skills, learn some new ones and discover your full potential
          with guidance from coaches, mentors and your team leaders.
        </CL>
        <CL weight="700">
          But don’t just take our word for it. Hear from some of our team:
        </CL>
      </S.CopyContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  background: ${colours.shell};
  background-size: cover;
  padding: 10% 0 5% 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;

  @media (min-width: ${Device.mobile}) {
    padding: 10% 0% 2% 0;
  }

  @media (min-width: ${Device.tablet}) {
    padding: 5% 10% 2% 10%;
  }

  @media (min-width: ${Device.desktop}) {
    flex-direction: row;
  }
`;

S.CopyContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10%;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (min-width: ${Device.tablet}) {
    padding: 0;
    gap: 3rem;
  }

  @media (min-width: ${Device.desktop}) {
    width: 60%;
    padding: 0;
    gap: 4rem;
  }
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.Bold = styled.span`
  font-weight: 700;
`;

S.Italic = styled.span`
  font-style: italic;
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
`;

S.FormWidthContainer = styled.div`
  width: 100%;
  margin: 2rem 0 0 0;
  padding: 0 2%;

  @media (min-width: ${Device.mobile}) {
    padding: 0 10%;
  }

  @media (min-width: ${Device.desktop}) {
    width: 45%;
    padding: 0;
    margin: 0;
  }
`;

export default CareersJoinContent;
